import { TravelerGroup } from '@reward-platform/order-schemas/common'
import useIntl from '../useIntl/useIntl'

type FormatFunc = (count: number) => string
type ExecutionMap = Record<TravelerGroup['ageGroup'], FormatFunc>

export const useTravellersMessageFormatters = () => {
  const intl = useIntl()

  const formatAdults: FormatFunc = (count) =>
    intl.formatMessage(
      {
        id: 'adults-count',
        defaultMessage: `{count} {count, plural, one {adult} other {adults}}`,
      },
      { count }
    )

  const formatSeniors: FormatFunc = (count) =>
    intl.formatMessage(
      {
        id: 'seniors-count',
        defaultMessage: `{count} {count, plural, one {senior} other {seniors}}`,
      },
      { count }
    )

  const formatYouths: FormatFunc = (count) =>
    intl.formatMessage(
      {
        id: 'youths-count',
        defaultMessage: `{count} {count, plural, one {youth} other {youths}}`,
      },
      { count }
    )

  const formatChildren: FormatFunc = (count) =>
    intl.formatMessage(
      {
        id: 'children-count',
        defaultMessage: `{count} {count, plural, one {child} other {children}}`,
      },
      { count }
    )

  const formatInfants: FormatFunc = (count) =>
    intl.formatMessage(
      {
        id: 'infants-count',
        defaultMessage: `{count} {count, plural, one {infant} other {infants}}`,
      },
      { count }
    )

  const formatTravelers: FormatFunc = (count) =>
    intl.formatMessage(
      {
        id: 'travelers-count',
        defaultMessage: `{count} {count, plural, one {traveller} other {travellers}}`,
      },
      { count }
    )

  const executionMap: ExecutionMap = {
    ADULT: formatAdults,
    SENIOR: formatSeniors,
    YOUTH: formatYouths,
    CHILD: formatChildren,
    INFANT: formatInfants,
    TRAVELER: formatTravelers,
  }

  const formatAgeGroupsAsList = (travelers: Pick<TravelerGroup, 'quantity' | 'ageGroup'>[]) =>
    travelers.map((group) => executionMap[group.ageGroup](group.quantity)).join(', ')

  return { formatAgeGroupsAsList }
}
